module.exports = __webpack_public_path__ + "media/images/lb/938-774d7509f6c296163240d832ec7bedf5.svg";